import React from 'react'
import { FaEnvelope, FaGlobe, FaMapMarkerAlt } from 'react-icons/fa'
import './DigiHealthLandingContact.css'

const DigiHealthLandingContact = () => {
  return (
    <section className="Digi-Health-Landing-Contact-section-bg">
      <div className="Digi-Health-Landing-Contact-section-container">
        <h2 className="Digi-Health-Landing-Contact-section-title">
          Join the Movement
        </h2>
        <p className="Digi-Health-Landing-Contact-section-desc">
          Whether you're a hospital administrator, a digital health startup, or a
          medical student with a passion for change—DigiHealth India welcomes
          collaborators who believe in healthcare innovation rooted in evidence,
          equity, and ethics.
        </p>
        <div className="Digi-Health-Landing-Contact-section-btns">
          <a 
            href='mailto:info@digihealthindia.com'
            target="_blank"
            rel="noopener noreferrer"
            className="Digi-Health-Landing-Contact-section-btn Digi-Health-Landing-Contact-section-btn-primary"
          >
            <FaEnvelope className="Digi-Health-Landing-Contact-section-btn-icon" />
            Get Involved
          </a>
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="Digi-Health-Landing-Contact-section-btn Digi-Health-Landing-Contact-section-btn-secondary"
          >
            Visit Website
          </a>
        </div>
        <div className="Digi-Health-Landing-Contact-section-cards">
          <div className="Digi-Health-Landing-Contact-section-card">
            <FaEnvelope className="Digi-Health-Landing-Contact-section-card-icon" />
            <div className="Digi-Health-Landing-Contact-section-card-title">
              Contact
            </div>
            <div className="Digi-Health-Landing-Contact-section-card-desc">
              info@digihealthindia.com
            </div>
          </div>
          <div className="Digi-Health-Landing-Contact-section-card">
            <FaGlobe className="Digi-Health-Landing-Contact-section-card-icon" />
            <div className="Digi-Health-Landing-Contact-section-card-title">
              Website
            </div>
            <div className="Digi-Health-Landing-Contact-section-card-desc">
              digihealthindia.com
            </div>
          </div>
          <div className="Digi-Health-Landing-Contact-section-card">
            <FaMapMarkerAlt className="Digi-Health-Landing-Contact-section-card-icon" />
            <div className="Digi-Health-Landing-Contact-section-card-title">
              Offices
            </div>
            <div className="Digi-Health-Landing-Contact-section-card-desc">
              New Delhi | Kochi
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DigiHealthLandingContact
